import { BlogList as BlogListSection } from '@/components/sections/blog'
import { SEO } from '@/components/shared/SEO'
import { Link } from 'react-router-dom'
import { blogPostBySlug } from '@/content/blogs'

export function Blog() {
  return (
    <>
      <SEO 
        title="Writing — Will Tran"
        description="Ideas on AI, vibe coding, product thinking, and building systems that amplify human capability."
        url="https://willtran.xyz/blog"
      />
      <main id="main-content" tabIndex={-1}>
        <section className="mx-auto max-w-6xl px-6 pt-28 lg:px-8 lg:pt-36" aria-labelledby="start-reading">
          <div className="section-label mb-4 text-accent-primary">Writing</div>
          <h1 className="text-4xl lg:text-6xl font-medium tracking-tight text-text-heading">Notes on building & learning</h1>
          <h2 id="start-reading" className="mt-10 text-2xl font-medium text-text-heading">Start here</h2>
          <p className="mt-3 text-base text-text-secondary">Selected notes on product work, AI, and the skills behind the tools.</p>
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {[
              ['three-levels-of-working-with-ai', 'Working with AI'],
              ['pm-kit-living-file-system-for-product-managers', 'Building PM-Kit'],
              ['the-best-career-investment-right-now-is-system-design-not-an', 'Systems thinking'],
            ].map(([slug, topic]) => (
              <Link key={slug} to={`/blog/${slug}`} className="rounded-xl border border-vibe-border bg-card-bg p-5 hover:border-accent-primary/50">
                <div className="section-label text-accent-primary">{topic}</div>
                <p className="mt-3 text-base leading-relaxed text-text-heading">{blogPostBySlug.get(slug)?.titleEn}</p>
              </Link>
            ))}
          </div>
        </section>
        <BlogListSection />
      </main>
    </>
  )
}
